import React from 'react'
import {connect} from 'react-redux'

class FullscreenState extends React.Component {

  //Maybe return styles that wrap the desktop layout together
  getDesktopWrap() {
    if (this.props.viewportMode === "portrait") {
      return {};
    }
    return {
      width: "40em",
      margin: "0 auto"
    };
  }

  render() {
    const style = {
      fontSize: this.props.viewportMode === "portrait" ? "0.6em" : "0.5em", //mobile, desktop
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-around"
    };
    return (
      <div style={{height: "100%"}}>
        <div style={style} className="menu-texture">
          <div style={{padding: "1em", ...this.getDesktopWrap()}}>
            <div className="menu-card">
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state, props) => {
  return {
    viewportMode: state.global.viewportMode
  }
})(FullscreenState)


// WEBPACK FOOTER //
// ./src/b5-home/FullscreenState.js